import { PayloadAction } from "./../shared/model/action.model";
export const LOGIN = "[Auth] Login";
export const LOGIN_SUCCESS = "[Auth] Login Success";
export const LOGIN_ERROR = "[Auth] Login Success";
export const LOGOUT = "[Auth] Logout";

export class Login implements PayloadAction {
  readonly type = LOGIN;
  constructor(public payload) {}
}

export class LoginSuccess implements PayloadAction {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload) {}
}

export class Logout implements PayloadAction {
  readonly type = LOGOUT;
  constructor(public payload?) {}
}

export class LoginError implements PayloadAction {
  readonly type = LOGIN_ERROR;
  constructor(public payload?) {}
}

export type All = Login | LoginSuccess | LoginError | Logout;
